import helpers from "@/helpers/helper";
import Axios from "./Axios";
import axios from "axios";
import { _authHeader } from "./auth._header";

const API_URL = helpers.API_ENDPOINT;

class fcnEventsService {
  getEvents(data) {
    return axios.get(API_URL + "fcn?page=" + data.page, {
      headers: _authHeader(),
    });
  }
}

export default new fcnEventsService();
